import React from "react";

const Icon: React.FC = (props) => {
    return (
        <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M6.52499 11.925L3.59999 9.00004L6.52499 6.07504C6.81749 5.78254 6.81749 5.31754 6.52499 5.02504C6.23249 4.73254 5.76749 4.73254 5.47499 5.02504L2.03249 8.46754C1.73999 8.76004 1.73999 9.23254 2.03249 9.52504L5.47499 12.975C5.76749 13.2675 6.23249 13.2675 6.52499 12.975C6.81749 12.6825 6.81749 12.2175 6.52499 11.925ZM11.475 11.925L14.4 9.00004L11.475 6.07504C11.1825 5.78254 11.1825 5.31754 11.475 5.02504C11.7675 4.73254 12.2325 4.73254 12.525 5.02504L15.9675 8.46754C16.26 8.76004 16.26 9.23254 15.9675 9.52504L12.525 12.975C12.2325 13.2675 11.7675 13.2675 11.475 12.975C11.1825 12.6825 11.1825 12.2175 11.475 11.925Z" fill="#00FFB0"/>
        </svg>
    );
};

export default Icon;